export default "__VITE_ASSET__bT7V_shQ__"